
import qs from 'qs';
import _ from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import axios from 'axios';
import React, { Component } from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import {findValuesByKey} from "../common/Utils";

export const FormContext = React.createContext();


export class FormProvider extends Component {

  static propTypes = {
    item: PropTypes.object.isRequired,
    url: PropTypes.string,
    postSave: PropTypes.func,
    postSaveMessage: PropTypes.string,
    showNonFieldErrors: PropTypes.bool,
    showForm: PropTypes.bool,
    onItemChanged: PropTypes.func,
    enterSubmit: PropTypes.bool
  };

  static defaultProps = {
    showNonFieldErrors: true,
    showForm: true,
    enterSubmit: false
  };

  constructor(props) {
    super(props);

    this.state = {
      item: _.clone(props.item),
      originalItem: _.clone(props.item),
      context: {},
      errors: {},
      loading: false,
      snackbarMessage: undefined,
      snackbarShow: false,
      snackbarSeverity: 'info'
    };

    this.formRef = React.createRef();
  }

  componentDidMount() {
    const { location } = this.props;
    if (location) {
      let urlValues = qs.parse(location.search.slice(1), { allowPrototypes: true });
      if (urlValues.form) {
        this.setValues(urlValues.form);
      }
    }
  }

  keydown = (e) => {
    const keyCode = e.key.toUpperCase();
    if (keyCode === 'F1') {
      this.save();
    }
  };

  save = (successCallback) => {
    const { item } = this.state;
    const { postSave, postSaveMessage } = this.props;
    const isNew = item.id ? false : true;

    this.setState({
      errors: {},
      loading: true
    });

    axios({
      method: isNew ? 'POST': 'PUT',
      url: this.props.url ? this.props.url : item.meta.url,
      data: item
    }).then(res => {
      this.setState({
        item: res.data
      });

      if (postSaveMessage) {
        this.setState({
          snackbarMessage: postSaveMessage,
          snackbarShow: true,
          snackbarSeverity: 'success'
        });
      }

      if (postSave && typeof postSave === 'function') {
        postSave(res.data);
      }

      if (successCallback && typeof successCallback === 'function') {
        successCallback(res.data);
      }
    }).catch(err => {
      const response = err.response;
      let errors = {};
      if (response) {
        if (response.data) {
          errors = response.data;
        }

        if (response.status === 404) {

        }
        else if (response.status === 400) {
          let snackbarMessage = 'Исправьте ошибки';
          if (errors) {
            let nonFieldErrors = findValuesByKey(errors, 'non_field_errors');
            if (nonFieldErrors.length > 0) {
              snackbarMessage = nonFieldErrors.join('\n');
            }
          }

          this.setState({
            snackbarMessage: snackbarMessage,
            snackbarShow: true,
            snackbarSeverity: 'error'
          });
        }
        else if (response.status === 403) {
          this.setState({
            snackbarMessage: errors['detail'],
            snackbarShow: true,
            snackbarSeverity: 'error'
          });
        }
      }

      this.setState({errors: errors});
    }).then(() => {
        this.setState({loading: false});
    });
  };

  setDateValue = (name, value) => {
    let item = this.state.item;
    if (value && moment(value).isValid()) {
      _.set(item, name, moment(value).format('YYYY-MM-DD'));
    }
    else {
      _.set(item, name, null);
    }
    this.setState({item: item});
  };

  setDateTimeValue = (name, value) => {
    let item = this.state.item;
    if (value && moment(value).isValid()) {
      _.set(item, name, moment(value).format('YYYY-MM-DDTHH:mm:ssZ'));
    }
    else {
      _.set(item, name, null);
    }
    this.setState({item: item});
  };

  setValue = (name, value) => {
    const { onItemChanged } = this.props;
    let { item, errors } = this.state;

    _.set(item, name, value);

    let error = _.get(errors, name);
    if (error) {
      _.unset(errors, name);
    }

    this.setState({item: item, errors: errors});
    if (onItemChanged) {
      onItemChanged(item);
    }
  };

  setValues = (values) => {
    const { onItemChanged } = this.props;
    let { item, errors } = this.state;
    Object.keys(values).forEach(name => {
      _.set(item, name, values[name]);

      let error = _.get(errors, name);
      if (error) {
        _.unset(errors, name);
      }
    });

    this.setState({item: item, errors: errors});
    if (onItemChanged) {
      onItemChanged(item);
    }
  };

  getValue = (name) => {
    const item = this.state.item;
    return _.get(item, name);
  };

  pushArrayValue = (name, value) => {
    const { onItemChanged } = this.props;
    let { item, errors } = this.state;
    let _item = _.get(item, name);
    if (_item === undefined || _item === null) {
      _item = [];
    }
    _item.push(value);
    _.set(item, name, _item);
    this.setState({item: item, errors: errors});
    if (onItemChanged) {
      onItemChanged(item);
    }
  };

  removeArrayValue = (name, index) => {
    const { onItemChanged } = this.props;
    let { item, errors } = this.state;
    let newItem = _.get(item, name);
    newItem.splice(index, 1);
    _.set(item, name, newItem);
    this.setState({item: item, errors: errors});
    if (onItemChanged) {
      onItemChanged(item);
    }
  };

  removeArrayValueById = (name, removeItem) => {
    const { onItemChanged } = this.props;
    let { item, errors } = this.state;
    let items = _.get(item, name);
    const index = items.findIndex((element) => {
      return element.id === removeItem.id;
    });
    items.splice(index, 1);
    _.set(item, name, items);
    this.setState({item: item, errors: errors});
    if (onItemChanged) {
      onItemChanged(item);
    }
  };

  hasFieldError = (name) => {
    const { errors } = this.state;
    const error = _.get(errors, name);
    return error && (_.isObject(error) || _.isArray(error)) ? true : false;
  };

  getFieldError = (name) => {
    const { errors } = this.state;
    const error = _.get(errors, name);
    if (_.isArray(error) && error.length > 0) {
      return error.join('. ');
    }
    else if (_.isObject(error)){

    }
  };

  getFieldErrorText = (name) => {
    const { errors } = this.state;
    const error = _.get(errors, name);
    if (_.isArray(error) && error.length > 0) {
      return error.join('. ');
    }
    else if (_.isObject(error)){
      let errorMessages = [];
      Object.keys(error).forEach(key => {
        const lineNumber = parseInt(key) + 1;
        errorMessages.push(`Строка ${lineNumber} - ${error[key][0]}`);
      });
      return errorMessages.join('\n');
    }
  };

  setFieldError = (name, error) => {
    let { errors } = this.state;
    _.set(errors, name, _.isArray(error) ? error : [error]);
    this.setState({errors: errors});
  };

  handleSubmit = (e, callback) => {
    e.preventDefault();
    this.save(callback);
  };

  handleFormSubmit = (e) => {
    e.preventDefault();

    if (this.state.enterSubmit) {
      this.save();
    }
  };

  snackbarClose = () => {
    this.setState({
      snackbarShow: false
    })
  };

  setContext = (name, value) => {
    let { context } = this.state;
    _.set(context, name, value);
    this.setState({context: context});
  };

  render() {
    const { errors, snackbarShow, snackbarSeverity, snackbarMessage } = this.state;
    const { showNonFieldErrors, showForm } = this.props;
    return (
      <FormContext.Provider value={{
        item: this.state.item,
        originalItem: this.state.originalItem,
        context: this.state.context,
        errors: this.state.errors,
        loading: this.state.loading,
        save: this.save,
        setDateValue: this.setDateValue,
        setDateTimeValue: this.setDateTimeValue,
        setValue: this.setValue,
        getValue: this.getValue,
        pushArrayValue: this.pushArrayValue,
        removeArrayValue: this.removeArrayValue,
        removeArrayValueById: this.removeArrayValueById,
        hasFieldError: this.hasFieldError,
        getFieldError: this.getFieldError,
        getFieldErrorText: this.getFieldErrorText,
        setFieldError: this.setFieldError,
        setContext: this.setContext,
        setValues: this.setValues,
        handleSubmit: this.handleSubmit
      }}>
        <Snackbar
          open={snackbarShow}
          autoHideDuration={4000}
          onClose={() => this.snackbarClose()}
          anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        >
          <MuiAlert elevation={6} variant="filled" onClose={() => this.snackbarClose()} severity={snackbarSeverity}>
            {snackbarMessage}
          </MuiAlert>
        </Snackbar>

        {showForm && (
          <form
            ref={this.formRef}
            autoComplete="off"
            noValidate
            onSubmit={(e) => this.handleFormSubmit(e)}
          >
            {(showNonFieldErrors && errors['non_field_errors']) && (
              <div className={'mb-10'}>
              </div>
            )}
            {this.props.children}
          </form>
        )}
        {!showForm && this.props.children}
      </FormContext.Provider>
    );
  }
}
